import apiClient from "./client";

export function getUsers() {
  return apiClient.get("/users").then((res) => res.data);
}

export function createUser(payload) {
  return apiClient.post("/users", payload).then((res) => res.data);
}

export function deleteUser(id) {
  return apiClient.delete(`/users/${id}`);
}

export function setUserRole(id, role) {
  return apiClient.put(`/users/${id}/role`, { role });
}
